<template>
    <div>
        <div class="paragraph">
            <div v-if="currentPage == 1">
                <p class="indent">总结国内外防治“白色污染”的实践经验，结合目前“白色污染”现状及其管理工作中存在的问题，我国防治“白色污染”应遵循“以宣传教育为先导，以强化管理为核心，以回收利用为主要手段，以替代产品为补充措施”的原则。</p>
                <p class="indent">防治“白色污染”，首先要解决“视觉污染”问题，使市容、景观有明显改善。这主要是靠宣传教育，引导市民形成良好的生活习惯；同时要依法强化管理，促使企业和个入对自己产生的废旧塑料包装物妥善收集、处理。防治“白色污染”，更重要的是解决废旧塑料包装物对生态环境长期的、深层次的危害。这主要是通过制定和实施有利于回收利用的法规和经济政策，对废旧塑料包装物实施全面回收利用；防治“白色污染”，还应加强研究开发符合实际的替代（绿色）包装用品。现就加速我国防治“白色污染”的进程提出以下对策建议：</p>
                <p class="bold">1、加强宣传教育。</p>
                <p class="indent">防治“白色污染”是一个系统工程，需要各部门、各行业的共同努力，需要全社会和全体公民的积极参与。要大力开展宣传教育，提高人们对“白色污染”危害的认识，提高全社会的环境意识，教育人们养成良好的卫生习愤。在自身严格遵守环保法规的同时，积极制止身边的不良行为。</p>
                <p class="bold">2、统一思想认识，强化管理。</p>
                <p class="indent">按照“以宣传教育为先导，以强化管理为核心，以回收利用为主要手段，以替代产品为补充措施”的防治原则，一是加强对“白色污染”危害性的宣传，引导和教育市民自觉防治“白色污染”；二是对大量产生废旧塑料包装物的行业（如铁路、水运、民航、旅游、饭店、餐饮、零售等），要通过强化管理，改变无人负责、无序堆放、随意抛弃的现象；三是采取强制措施，从回收集中产生的废旧塑料包装物（如一次性泡沫餐盒）入手，逐步提高废旧塑料包装物回收利用率；四是加强替代包装产品的开发、研究，努力减少废旧塑料包装物的产生量等。</p>
                <p class="bold">3、尽快制定颁布国家防治“白色污染”的有关法规，明确生产者、销售者和消费者回收利用废旧塑料包装物的义务和法律责任。</p>
                <p class="indent">应对塑料包装物的生产、经营、消费等各个环节，分别制定具体的控制措施和引导政策，控制不易回收利用的废旧塑料包装物的产生量，鼓励提高废旧塑料包装物的回收利用率。</p>
            </div>
            <div v-if="currentPage == 2">
                <p class="bold">4、制定适当的经济政策，建立在市场经济条件下消除“白色污染”的良性运作机制。</p>
                <p class="indent">运用经济手段，鼓励和促进废旧塑料包装物的“减量化、资源化、无害化”，节约和综合利用资源，防治“白色污染”，保护生态环境。</p>
                <p class="bold">5、多用环保袋，少用塑料袋。</p>
                <p class="indent">地球是我们赖以生存的家园，并为我们提供了如此美丽的环境。但是随着社会经济的迅速发展和城市人口的高度集中，生活垃圾的产量正在逐步增加，我们的这个家园正在被垃圾所包围。</p>
                <p class="indent">近年来，由于大量废旧包装塑料膜、塑料袋和一次性不可降解的塑料餐具使用 量激增，并且任意抛弃，各大中城市都普遍形成了严重的白色污染。它已同汽 车尾气、有磷洗涤剂一起列被为今年我国环保治理三大重点。</p>
                <p class="indent">塑料是一种很难处理的生活垃圾，它混入土壤能够影响作物吸收水分和养分，导致农作物减产；填埋起来，占用土地并且上百年才可以降解。大量散落 的塑料还容易造成动物误食致死，北京南苑的麋鹿因误食附近垃圾场飞入的塑 料袋而死于非命。塑料易成团成捆，它甚至能堵塞水流，造成水利设施、城市 设施故障，酿成灾害。</p>
                <p class="indent">我国泡沫餐具的生产和使用量极大，食品包装、购物买菜的塑料袋使用数量也 是惊人的。据粗略估计，本世纪我国的白色垃圾大约有800多万吨。塑料制品是所有生活废弃物中最难处理的部分之一，也一直是一个世界性的难题、一般 来说，采用卫生填埋、高温堆肥和焚烧这三种方法，基本上可以使垃圾处理达 到减量化、资源化和无害化。但我国的情况不容乐观，自前垃圾收集、处理远 未形成有序体系。拿北京来说，垃圾收集还未完成垃圾袋装化，更不用提分类 收集。</p>
                <p class="indent">焚烧虽然可以销毁塑料袋，不过建一个垃圾焚烧厂是同规模填埋场的20倍的投入。至于人工降解产生有机油料的做法，需要较高纯度的塑料制品，大规模处理是不现实的。因此，卫生填埋成为目前能收集塑料的主要办法。北京已建起阿苏卫、北神树和安定3个垃圾卫生填埋场，垃圾填埋场底部铺设了厚厚的防渗层，并随着垃圾的堆积，上面不断用土覆盖，然后再造植被，以便保证垃圾在一个四周密闭的空间范围，不会污染地下水、土壤和周围的空气。但是，以安定垃圾填埋场为例，面积达300亩的一块土地也只够北京一个宣武区使用14年。</p>
                <p class="indent">抵制使用不可降解塑料的做法于不久前得到一些商场的响应，他们尝试出售可降解的垃圾袋，但是购买者寥寥，因为这种垃圾袋价格在1元以上，并且不能承受较大的重量。万客隆提倡使用布袋，效果也不理想。</p>
            </div>
            <div v-if="currentPage == 3">
                <p class="indent">标本兼治是解决问题的最好办法，专家认为，一方面应及时有效地处理既生垃圾，一方面用能降解、易降解的制品代替塑料。1998年11月，一种以秸秆作成的一次性餐具首次摆上了北京百盛购物中心的快餐桌。这种餐具不但安全卫生，而且一次性使用后入土即为肥料，入水可成为鱼饲料，弃置路边，几天后就随风而去了。在1998年12月13日的“绿色一次性餐具交流会”上，100多家企业展示了他们用稻壳、纸浆、淀粉等为原料制作的餐具。一种生物全降解一次性快餐盒经北京一轻研究所30多名研究人员近三年的研究，日前已通过检测。测试证实，该餐盒使用后暴露在大自然中，40天内全部变为水和二氧化碳。这种餐盒以淀粉（玉米、木薯淀粉）为原料，加入一年生植物纤维粉和生物防水胶喷注到模具内加热发泡成型。各种新生的替代产品正处在起步阶段，但尚没有达到大规模生产推广的水平。</p>
                <p class="indent">另外；民众的环境保护意识仍然比较落后，这其实是阻碍白色污染治理的一个重要因素。治理白色垃圾的第一步就是垃圾分装，这只有在大多数人的自觉环保意识建立起来之后才有望进行。所以，治理白色污染的最重要一点是提高每个人的环境意识。因为白色垃圾需要百年以上时间才可以在自然界自然降解，所以解决它的污染问题真的可以称为百年难题。</p>
            </div>
        </div>
        <div class="link-content">
            <div class="bottom margin-left">
                <div class="image-col float-left">
                    <img src="../../../assets/images/wenben.jpg" />
                </div>
                <div class="text-col float-left"><span><span class="sp-text">页码: </span></span> <span :class="{ active: currentPage == 1 }" class="page" @click="currentPage = 1">1</span> <span class="sp-text">-</span> <span :class="{ active: currentPage == 2 }" class="page" @click="currentPage = 2">2</span> <span class="sp-text">-</span> <span :class="{ active: currentPage == 3 }" class="page" @click="currentPage = 3">3</span>&nbsp;&nbsp;&nbsp;<span class="sp-text">-</span></div>
                <div class="image-col float-left no-left">
                    <img style="cursor: pointer" @click="back" src="../../../assets/images/return.jpg" />
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WhitePollutionPrevent",
        data() {
            return {
                currentPage: 1
            }
        },
        methods: {
            back() {
                this.$emit('onIndexChanged',1);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .paragraph {
        .red {
            color: #ff0000;
        }
        .margin-top {
            margin-top: 20px;
        }
        p {
            font-size: 13px;
            color: #800000;
        }
    }
    .link-content {
        margin-top: 2%;
        margin-left: 10%;
        width: 80%;
        .bottom {
            float: left;
            width: 100%;
            height: 80px;
            margin-left: 50px;
            .float-left {
                float: left;
            }
            .image-col {
                height: 30px;
                margin-left: 15px;
                &.no-left {
                    margin-left: 5px;
                }
            }
            .text-col {
                margin-left: 15px;
            }
            img {
                width: 25px;
                height: 25px;
            }
            .margin-left {
                margin-left: 40%;
            }
            a, span {
                font-size: 15px;
                color: #000000;
                text-decoration: none;
                cursor: pointer;
                &.sp-text {
                    color: #cbf8e2;
                }
            }
            .page {
                padding: 3px 8px;
                border: 1px #aaa solid;
                background: #eee;
                box-shadow: -1px -1px 2px #ccc inset;
                font-weight: bold;
                &.active {
                    background: #4a97d4;
                    border: 1px #175187 solid;
                    color: #fff;
                    box-shadow: -1px -1px 2px #7894bd inset;
                }
            }
        }

    }
</style>